import { memo } from 'react'

import dynamic from 'next/dynamic'

import { Layout } from 'modules/layout'

import Hero from './hero'
import HowProtectVideo from './how-protect-video'
import SafetyTip from './safety-tip'

const About = dynamic(() => import('./about'))
const ReportScam = dynamic(() => import('./report-scam'))
const KnowAndDiscover = dynamic(() => import('./know-and-discover'))

const SecurityFraud = memo(() => (
  <Layout hasCTA>
    <Hero />
    <About />
    <ReportScam />
    <KnowAndDiscover />
    <HowProtectVideo />
    <SafetyTip />
  </Layout>
))

SecurityFraud.displayName = 'SecurityFraud'

export default SecurityFraud
